module.exports = __webpack_public_path__ + "assets/img/user-7.6968332d.jpg";